/** Empty transform object with no transformation properties */
const meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  flipX: false,
  flipY: false,
  rotate: 0
};
var meaninglessTransform$1 = meaninglessTransform;

export { meaninglessTransform$1 as m };
//# sourceMappingURL=meaninglessTransform-2ba19953.js.map
